import { axiosInstance } from "./axiosInstance"

export const getCart = async () => {
    // 💡 추후 장바구니 목록 조회 시 사용할 주소도 미리 맞춰둡니다.
    const response = await axiosInstance.get("/api/carts")
    return response.data
}

// 💡 payload 타입에 optionId를 추가했습니다.
export const addCartItem = async (payload: {
    productId: number
    quantity: number
    memberId?: any // (선택) 회원 ID
    optionId?: number // 💡 새로 추가된 옵션 ID (단일 상품일 수 있으므로 ? 사용)
}) => {
    // 💡 방금 우리가 백엔드에 만든 컨트롤러 주소(/api/carts)로 변경
    const response = await axiosInstance.post("/api/carts", payload)
    return response.data
}

// 장바구니 수량 변경 API
export const updateCartItemQuantity = async (cartItemId: number, quantity: number) => {
    const response = await axiosInstance.patch(`/api/carts/${cartItemId}`, { quantity });
    return response.data;
};

// 장바구니 상품 삭제 API
export const deleteCartItem = async (cartItemId: number) => {
    const response = await axiosInstance.delete(`/api/carts/${cartItemId}`);
    return response.data;
};